function myOrdersOnload() {

    /**
     * ACTION BUTTON
     */
    $("[data-action]").click(function (e) {
        e.preventDefault();
        var data = $(this).data();
        var modal_size = "md";
        var modal = "#modal_" + modal_size;
        var modal_title = $(".modal_title_" + modal_size);
        var modal_content = $(".modal_content_" + modal_size);

        $.ajax({
            url: data.action,
            type: "POST",
            data: data,
            beforeSend: () => {
                loaderShow();
            },
            success: (result) => {
                loaderClose();
                setTimeout(function () {
                    modal_title.html("PEDIDO: <b>" + data.order + "</b>");
                    modal_content.html(result);
                    openModal(modal);
                }, 400);
            },
            error: function () {
                var message = "<div class='message error icon-warning'>Desculpe mas não foi possível processar a requisição. Favor tente novamente!</div>";

                setTimeout(function () {
                    modal_title.html("Ops!");
                    modal_content.html(message);
                    openModal(modal);
                }, 400);

                loaderClose();
            }
        });

    });


}

